/**
 * Created by AK on 5/24/2017.
 */

/**
 * Exponential backoff algorithm
 * @param c
 * @returns {number}
 * @constructor
 */
function E(c) {
    const N = 2 ** c - 1;

    return (1 / (N + 1)) * ((N * (N + 1)) / 2);
}

/**
 * Creates a new iterator for an exponential backoff
 * @param {Number} [factor=1] - Scale factor for returned number (0,10]
 * @param {Number} [max=10] - Max `c` for algorithm
 * @returns {Iterator}
 */
export default function *exponentialBackoff(factor = 1, max = 10) {
    let c = 0;

    while(true) {
        if(c !== max) {
            c++;
        }

        yield E(c) * factor;
    }
}
